export function getLanguageFromLocaleString(locale: string): string {
    return locale.substr(0, 2);
}
